import { COLORS } from '@btime/constants'
import React from 'react'

import { usePdfOptionsForm, useShouldHideColors } from './options/_form/PdfOptionsFormHandler'
import fontSizes from '../../utils/constants/fontSizes'

const _Text = ({
  size,
  color,
  bgColor,
  underlineColor,
  bold,
  semibold,
  thin,
  align,
  noWrap,
  preLine,
  inline,
  style = {},
  ...props
}) => {
  const hideColors = useShouldHideColors()
  const { fontBase, fontBaseColor } = usePdfOptionsForm()
  const fontSize = fontSizes[size || 'p']

  style = {
    display: inline ? 'inline-block' : 'block',
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Nunito', 'Montserrat', sans-serif",
    color: hideColors ? COLORS.black : color || fontBaseColor,
    fontWeight: bold ? 900 : semibold ? 700 : 400,
    fontSize: fontSize ? fontSize * fontBase : size,
    textAlign: align || 'left',
    lineHeight: 1.5,
    backgroundColor: bgColor,
    textDecoration: !!underlineColor ? 'underline' : 'none',
    textDecorationColor: underlineColor,
    ...(noWrap ? { whiteSpace: 'nowrap' } : {}),
    ...(preLine ? { whiteSpace: 'pre-line' } : {}),
    ...style
  }

  return <span {...props} style={style} />
}

export const Bold = props => <_Text bold inline {...props} />

export default _Text
